import SlackFormatter from "./slackFormatter.service";

const slackFormatterModule = angular
  .module("app.services.slackFormatter", [])
  .service("SlackFormatter", SlackFormatter);

export default slackFormatterModule;



// WEBPACK FOOTER //
// ./src/services/slackFormatter/slackFormatter.module.js